export default __webpack_public_path__ + "static/media/Flexi-Savings-Plan-Brochure.5f101656.pdf";